import styled, { css } from 'styled-components';
import { HTMLAttributes, ReactNode } from 'react';
import colors from '/css/colors';

interface Props extends HTMLAttributes<HTMLDivElement> {
    variant?: 'default' | 'info' | 'warning' | 'success' | 'grey' | 'green';
    children: ReactNode;
}

const InfoCard = ({ variant = 'default', children, ...rest }: Props) => {
    return (
        <Card variant={variant} {...rest}>
            {children}
        </Card>
    );
};

const Card = styled.div<Omit<Props, 'children'>>`
    width: 100%;
    padding: 16px 24px;
    background: ${colors.mintM6};
    border-radius: 12px;

    ${(p) =>
        p.variant === 'grey' &&
        css`
            background: ${colors.grey2};
        `};

    ${(p) =>
        p.variant === 'success' &&
        css`
            background: ${colors.greenM5};
        `};

    ${(p) =>
        p.variant === 'warning' &&
        css`
            background: ${colors.orangeM4};
        `};

    ${(p) =>
        p.variant === 'info' &&
        css`
            background: ${colors.yellowM3};
        `};
    ${(p) =>
        p.variant === 'green' &&
        css`
            background: ${colors.greenM5};
        `};
`;

export default InfoCard;
